import { render, staticRenderFns } from "./influencer_suggest.vue?vue&type=template&id=3f4f8908&"
import script from "./influencer_suggest.vue?vue&type=script&lang=js&"
export * from "./influencer_suggest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports